function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.022 0H4.97804C3.65778 0 2.3916 0.494315 1.45804 1.3742C0.524471 2.25409 0 3.44747 0 4.69182L0 11.31C0.000518769 12.5541 0.525219 13.747 1.45873 14.6264C2.39223 15.5059 3.65812 16 4.97804 16H19.022C20.3419 16 21.6078 15.5059 22.5413 14.6264C23.4748 13.747 23.9995 12.5541 24 11.31V4.69182C24 3.44747 23.4755 2.25409 22.542 1.3742C21.6084 0.494315 20.3422 0 19.022 0V0ZM15.6443 8.32393L9.08087 11.2744C9.0417 11.2914 8.99867 11.2989 8.95563 11.2964C8.91259 11.2939 8.87089 11.2813 8.83426 11.2599C8.79762 11.2385 8.7672 11.2088 8.7457 11.1736C8.72421 11.1383 8.71232 11.0986 8.71109 11.058V4.96658C8.71042 4.92394 8.72153 4.88188 8.74332 4.84452C8.76511 4.80715 8.79683 4.77577 8.83538 4.75346C8.87392 4.73114 8.91796 4.71865 8.96317 4.71722C9.00839 4.71579 9.05322 4.72546 9.09326 4.74529L15.6443 7.87522C15.6905 7.89454 15.7296 7.92605 15.7571 7.96592C15.7846 8.0058 15.7992 8.05233 15.7992 8.09988C15.7992 8.14744 15.7846 8.19397 15.7571 8.23385C15.7296 8.27372 15.6905 8.30523 15.6443 8.32455V8.32393Z",
  fill: "#D9D9D9"
});

const SvgIconYoutubeDisabled = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 16,
  viewBox: "0 0 24 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconYoutubeDisabled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-youtube-disabled.b38d9880.svg";
export { ForwardRef as ReactComponent };